module.exports = "pegasus/assets/hexagon-snapchat.png";